import React, { useEffect, useState } from "react";
import {
  IconButton,
  Paper,
  Table,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Tooltip,
} from "@mui/material";
import AssignmentIndRoundedIcon from "@mui/icons-material/AssignmentIndRounded";

import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

const AssociateTableOperator = ({ operatorData }) => {
  const { t } = useTranslation();
  const [user, setUser] = useState();
  const navigate = useNavigate();
  const handleOpen = (Id) => {
    setUser(Id);
  };

  useEffect(() => {
    if (user?.id) navigate(`/auth/admin/${t("operators")}/${user?.id}`);
  }, [user?.id, navigate, t]);

  return (
    <TableContainer component={Paper} elevation={4}>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>{t("Name")}</TableCell>
            <TableCell>{t("Surname")}</TableCell>
            <TableCell>Email</TableCell>
            <TableCell>{t("Actions")}</TableCell>
          </TableRow>
        </TableHead>

        {operatorData?.map((el) => (
          <TableRow key={el.id}>
            <TableCell>{el.name}</TableCell>
            <TableCell>{el.surname}</TableCell>
            <TableCell>{el.email}</TableCell>
            <TableCell>
              <Tooltip title={t("Card") + " " + t("Operator")}>
                <IconButton variant="outlined" onClick={() => handleOpen(el)}>
                  <AssignmentIndRoundedIcon fontSize="small" />
                </IconButton>
              </Tooltip>
            </TableCell>
          </TableRow>
        ))}
      </Table>
      {operatorData?.length === 0 && (
        <p className="flex justify-center py-2 text-gray">
          {`${t("NoOperators")}`}
        </p>
      )}
    </TableContainer>
  );
};

export default AssociateTableOperator;
